import React from 'react';
import {
    BooleanField,
    Datagrid,
    DateField,
    EditButton,
    EmailField,
    Filter,
    List,
    //ShowButton,
    TextField,
    TextInput,
} from 'react-admin';

const UserFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="username" alwaysOn />
    </Filter>
);

const userRowStyle = (record, index) => ({
    backgroundColor: record.deleted_at !== null ? '#cfcfcf' : 'white'
});

export const UserList = (props) => (
    <List {...props} filters={<UserFilter />} sort={{field: 'username', order: 'ASC'}} bulkActionButtons={false}>
        <Datagrid rowStyle={userRowStyle}>
            <TextField source="username" />
            <TextField source="first_name" />
            {/*
            <TextField source="last_name" />
            */}
            <EmailField source="email" />
            <TextField source="roles" />
            <BooleanField source="enabled" label="Enabled?" />
            {/*
            <DateField disabled source="updated_at" showTime />
            <DateField disabled source="created_at" showTime />
            */}
            <DateField source="deleted_at" label="Deleted?" sortBy="deletedAt" showTime />
            <EditButton />
        </Datagrid>
    </List>
)
